import React, { Component, useState } from "react";
import mercuryLogo from "../mercury.png";
import plutoLogo from "../pluto.png";
import Web3 from "web3";

import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";

const BuyErc20 = ({ BuyTokens, PlutoBalance, MercuryBalance }) => {
  const [input, setInput] = useState(null);
  const [output, setOutput] = useState(null);
  return (
    <>
      <form
        className="mb-3"
        onSubmit={(event) => {
          event.preventDefault();
          if (Number(input) > Number(PlutoBalance)) {
            toast("Dont't have enough Pluto Tokens", { type: "warning" });
            return;
          }
          if (Number(MercuryBalance) < Number(input)) {
            toast("Dont't have enough Mercury Tokens", { type: "warning" });
            return;
          }
          const weiValue = Web3.utils.toWei(input, "ether");
          BuyTokens(weiValue);
        }}
      >
        <div>
          <label className="float-left" style={{ float: "left" }}>
            <b>Input</b>
          </label>
          <span className="float-right text-muted" style={{ float: "right" }}>
            Balance: {MercuryBalance}
          </span>
        </div>
        <div className="input-group mb-4">
          <input
            type="text"
            onChange={(event) => {
              const tokenAmount = event.target.value.toString();
              setInput(event.target.value);
              setOutput(tokenAmount * 10);
            }}
            value={input}
            className="form-control form-control-lg"
            placeholder="0"
            required
          />
          <div className="input-group-append">
            <div className="input-group-text">
              <img src={mercuryLogo} height="32" alt="" />
              &nbsp; Mercury
            </div>
          </div>
        </div>
        <div>
          <label className="float-left">
            <b>Output</b>
          </label>
          <span className="float-right text-muted" style={{ float: "right" }}>
            Balance: {PlutoBalance}
          </span>
        </div>
        <div className="input-group mb-2">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="0"
            value={output}
            disabled
          />
          <div className="input-group-append">
            <div className="input-group-text">
              <img src={plutoLogo} height="32" alt="" />
              &nbsp;&nbsp;&nbsp; Pluto
            </div>
          </div>
        </div>
        <div className="mb-5">
          <span className="float-left text-muted">Exchange Rate</span>
          <span className="float-right text-muted" style={{ float: "right" }}>
            1 Mercury = 10 Pluto
          </span>
        </div>
        <button type="submit" className="btn btn-primary btn-block btn-lg">
          SWAP!
        </button>
      </form>
    </>
  );
};

export default BuyErc20;
